import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import ModalContainer from "../UIElements/modal-container";
import { useTheme } from "@mui/material/styles";

import useResponsive from "../../hooks/useResponsive";
import { headerSty } from "../table-styles";
import { labelStyles, textSty } from "../UIElements/styles-input";
import { LoadingButton } from "@mui/lab";
import { useMutation } from "@tanstack/react-query";
import { apiSendSupportUpdate } from "../../api/support";
import { useNotificationService } from "../notification";
import { useAuth } from "../../hooks/useAuth";
import { useState } from "react";
import LoadingSpinner from "../UIElements/loadingSpinner";

export const SupportDetailsModal = ({
  open,
  modalHandler,
  supportData,
  handleRefresh,
}: {
  open: boolean;
  modalHandler: () => void;
  supportData: any;
  handleRefresh: () => void;
}) => {
  const theme = useTheme();
  const { token } = useAuth();
  const isMedium = useResponsive("down", "md", "xl");
  const { showNotification } = useNotificationService();

  const mutation = useMutation({
    mutationFn: (fieldValues: {
      userId: string;
      token: string;
      status: string;
    }) => apiSendSupportUpdate(fieldValues),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        handleRefresh();
        modalHandler();
      }
    },
    onError: (error) => {
      showNotification("Fetch process failed", "error");
    },
  });

  const handleResolve = (status: string) => {
    const data = {
      token,
      userId: supportData?._id,
      status: status,
    };
    if (!!status) {
      mutation.mutate(data);
    }
  };
  
  return (
    <ModalContainer
      sx={{
        borderRadius: "16px",
      }}
      size={"md"}
      openModal={open}
      fullWidth={true}
      handleModal={() => {}}
    >
      <Box sx={{ background: "#fff", padding: 4, borderRadius: "16px" }}>
        <Box>
          <Typography
            sx={{ ...headerSty, textAlign: "left", my: 2, color: "black" }}
            variant="subtitle2"
          >
            Support Information
          </Typography>
          <Box>
            <Stack
              direction={isMedium ? "column" : "row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              sx={{ my: 3, gap: 2 }}
            >
              <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
                <Typography sx={{ ...labelStyles, mb: 0 }}>
                  Facility Name
                </Typography>
                <Typography sx={{ ...textSty }}>{supportData?.name}</Typography>
              </Stack>
              <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
                <Typography sx={{ ...labelStyles, mb: 0 }}>
                  Description
                </Typography>
                <Typography sx={{ ...textSty }}>
                  {supportData?.description}
                </Typography>
              </Stack>
            </Stack>
            <Stack
              direction={isMedium ? "column" : "row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              sx={{ my: 3, gap: 2 }}
            >
              <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
                <Typography sx={{ ...labelStyles, mb: 0 }}>
                  Issue Type
                </Typography>
                <Typography sx={{ ...textSty }}>
                  {supportData?.issue_type}
                </Typography>
              </Stack>
              <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
                <Typography sx={{ ...labelStyles, mb: 0 }}>Status</Typography>
                <Typography sx={{ ...textSty }}>
                  {supportData?.status}
                </Typography>
              </Stack>
            </Stack>
            <Stack
              direction={isMedium ? "column" : "row"}
              alignItems={"center"}
              justifyContent={"space-between"}
              sx={{ my: 3, gap: 2 }}
            >
              <Stack sx={{ width: isMedium ? "100%" : "49%" }}>
                <Typography sx={{ ...labelStyles, mb: 0 }}>
                  Facility Id
                </Typography>
                <Typography sx={{ ...textSty }}>{supportData?._id}</Typography>
              </Stack>
            </Stack>
          </Box>

          {/*  */}
        </Box>
        <Stack direction={"row"} justifyContent={"center"}>
          {mutation.isPending && <CircularProgress />}
        </Stack>
        <Stack
          direction={"row"}
          justifyContent={"space-around"}
          flexWrap={"wrap"}
          sx={{ gap: 3, mt: 3 }}
        >
          <Button
            onClick={() => handleResolve("resolved")}
            variant="contained"
            sx={{ minWidth: 160, color: 'white' }}
            color="success"
          >
            Resolved
          </Button>
          <Button
            onClick={() => handleResolve("pending")}
            variant="contained"
            sx={{ minWidth: 160, color: 'white' }}
            color="warning"
          >
            Pending
          </Button>
          <Button
            onClick={() => handleResolve("unresolved")}
            variant="contained"
            sx={{ minWidth: 160 }}
            color="error"
          >
            Unresolved
          </Button>
          <Button
            onClick={modalHandler}
            sx={{
              width: 150,
              borderRadius: "4px",
              background: theme.palette.lightBlue.light,
            }}
            variant="outlined"
          >
            Cancel
          </Button>
        </Stack>
      </Box>
    </ModalContainer>
  );
};
